<template>
  <div class="container popular-petition-list mt-5" v-if="popularPetitions_list.length">
    <h4 class="bold">{{ $t('action.popularPetitions', locale) }}</h4>
    <div class="justify-content-center mb-0">
      <div>
        <VueSlickCarousel
          v-bind="settings"
          class="actions d-md-flex flex-wrap justify-content-center"
        >
          <div
            v-for="(petition, i) in popularPetitions_list"
            :key="i"
            class="p-card d-flex flex-column justify-content-between mb-3 text-center popular-petition"
          >
            <img class="mb-1" :src="petition.thumbnail" :alt="petition.title" />
            <p class="bold px-2">{{ petition.title }}</p>
            <div class="p-card__info px-2 pb-2">
              <a :href="petition.canonical_url">
                <button class="btn btn-xsm btn-sign mb-1 bold" :href="petition.canonical_url">
                  {{ $t('action.signNow', locale) }}
                </button>
              </a>

              <div class="popular-p-card__meta">
                <span>
                  <SignatureIconSVG />
                  <span>
                    {{ petition.signature_count }}
                    {{ $tc('action.signaturesPlural', petition.signature_count, locale) }}
                  </span>
                </span>
                <span>
                  <ClockIconSVG />
                  <span>
                    {{
                      $tc('action.monthsAgoPlural', displayDate(petition.created), locale, {
                        date: displayDate(petition.created)
                      })
                    }}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </VueSlickCarousel>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SignatureIconSVG from './assets/images/symbols/signatures.svg?inline'
import ClockIconSVG from './assets/images/symbols/clock.svg?inline'

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'PopularPetitions',
  components: { SignatureIconSVG, ClockIconSVG, VueSlickCarousel },
  props: {
    endpoint: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      locale: document.documentElement.lang || 'en',
      popularPetitions_list: [],
      loading: false,
      settings: {
        arrows: true,
        dots: true,
        draggable: true,
        infinite: false,
        speed: 200,
        accessibility: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        variableWidth: true,
        pauseOnDotsHover: true,
        pauseOnFocus: true,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: true,
              initialSlide: 0
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
              dots: false
            }
          }
        ]
      }
    }
  },
  computed: {
    ...mapState('actionForm', ['popularPetitions'])
  },
  // Probably don't need getnextpage as we don't have next pages
  mounted() {
    this.getPage()
  },
  methods: {
    showNext() {
      this.$refs.carousel.next()
    },

    async getPage() {
      this.$store.commit('actionForm/SET_PETITION_ENDPOINT', this.endpoint)
      this.$store.commit('actionForm/SET_PETITION_PAGE', this.page)
      await this.$store.dispatch('actionForm/fetchPopularPetitionData')
      this.popularPetitions_list.push(...this.popularPetitions.results)
      this.loading = false
      if (this.popularPetitions_list.length < 4) {
        this.settings.slidesToShow = this.popularPetitions_list.length
        this.settings.slidesToScroll = this.popularPetitions_list.length
      }
    },
    displayDate(rawDateString) {
      const startDate = new Date(rawDateString)
      const endDate = new Date()
      const months =
        endDate.getMonth() -
        startDate.getMonth() +
        12 * (endDate.getFullYear() - startDate.getFullYear())
      return months
    }
  }
}
</script>

<style lang="scss" scoped>
// the box containing each individual popular petition
.popular-petition {
  box-shadow: 0 1px 16px 0 rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  min-height: 310px;
  min-width: 262px;
  max-width: 280px;
  img {
    max-width: 100%;
  }

  // # of signatures and time ago
  .popular-p-card__meta {
    font-size: 10px;
    color: #7c7c7c;
    display: flex;
    justify-content: space-around;
    span {
      display: flex;
      align-items: center;
      svg {
        margin-right: 0.2rem;
      }
      span {
        padding-top: 0.3rem;
      }
    }
    @media (max-width: 980px) {
      display: none !important;
    }
  }
}
// This is the entire section container which holds the popular petitions
.popular-petition-list {
  max-width: 1185px;
  h4 {
    font-size: 18px;
    margin: 1.3125rem;
    @media (max-width: 768px) {
      text-align: center;
    }
  }
  .btn-sign {
    min-width: 100%;
    font-size: 20px;
    border-radius: 0;
    padding: 0.1rem;
    font-weight: 800;
  }
  .actions {
    column-gap: 1.3125rem;
    row-gap: 2rem;
  }
}
</style>
